export default "__VITE_ASSET__CpG_WPb7__"